import { MEDIA_CENTER_RAILS_TYPE } from 'hb-react/frontoffice/apps/MediaCenter/utils/queryUtils';
import toggleLike from 'hb-react/shared/components/DesignSystem/Reactions/utils/toggleLike';
import FilePreview from 'hb-react/shared/components/FilePreview';

const MediaCenterFilePreview = ({
  categories,
  filePreview,
  folderUrl,
  handleKeyNavigation,
  hasPagination,
  isLoadingLikes,
  likes,
  nextUrl,
  onCloseModal,
  onLikeCallback,
  onSwipedLeft,
  onSwipedRight,
  previousUrl,
  search,
  showReactions,
}) => (
  <FilePreview
    categories={categories}
    content={{
      hideNextUrl: !hasPagination,
      hidePreviousUrl: !hasPagination,
      nextUrl: nextUrl ? { pathname: nextUrl, search } : '',
      onKeyUp: handleKeyNavigation,
      previousUrl: previousUrl ? { pathname: previousUrl, search } : '',
    }}
    file={filePreview}
    folderUrl={folderUrl}
    isLoading={false}
    onCloseModal={onCloseModal}
    onSwipedLeft={onSwipedLeft}
    onSwipedRight={onSwipedRight}
    reactions={{
      displayCommentsByDefault: true,
      id: filePreview.id,
      initialLikes: likes,
      initialTotalComments: filePreview?.total_comments,
      isLoadingLikes,
      onLikeCallback,
      onTogglePostLike: toggleLike,
      railsType: MEDIA_CENTER_RAILS_TYPE,
      type: MEDIA_CENTER_RAILS_TYPE,
    }}
    screenReadersCloseButtonText={s__(
      'MediaCenterAccessibility|Close preview of media center file',
    )}
    showReactions={showReactions}
  />
);

export default MediaCenterFilePreview;
